import axios from 'axios'
import { AuthModel, UserModel } from './_models'
import { getBaseApiUrl } from 'app/configs/configs'

const API_URL = getBaseApiUrl();

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/me`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(email: string, password: string) {
    return axios.post<AuthModel>(LOGIN_URL, {
        email,
        password,
    })
}

declare const window: any
export function updateWebpushrSid() {
    console.debug('trying to update webpushr sid');
    if (!window?.webpushr) {
        console.error('webpushr is not loaded');
    }
    window.webpushr('fetch_id', function(sid: string) {
        console.debug('webpushr sid: ' + sid + ' (updating)');
        axios.post<{ success: boolean }>(`${API_URL}/update-admin-webpushr-sid`, {
            webpushr_sid: sid,
        }).then((res) => {
            console.debug('webpushr subscriber id: ' + sid + '(updated)', res?.data);
        });
    });
}

// Server should return AuthModel
export function register(
    email: string,
    firstname: string,
    lastname: string,
    password: string,
    password_confirmation: string
) {
    return axios.post(REGISTER_URL, {
        email,
        first_name: firstname,
        last_name: lastname,
        password,
        password_confirmation,
    })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
    return axios.post<{ success: boolean }>(REQUEST_PASSWORD_URL, {
        email,
    })
}

export function getUserByToken(token: string) {
    return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
        api_token: token,
    })
}
